<template>
  <content-block title="备件清单">
    <TableWithPagination
      :tableData="list" row-key="index"
      :editConfig="{ trigger: 'munal', mode: 'cell' }"
      :columnList="columnList"
      size="mini" />
  </content-block>
</template>
<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
export default {
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    columnList () {
      return [
        {
          tooltip: true,
          label: '备件编码',
          prop: 'code',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '备件名称',
          prop: 'name',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '备件型号',
          prop: 'model',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '操作内容',
          prop: 'operationTypeDesc',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '原厂/兼容',
          prop: 'compatibilityRequirementDesc',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '质保期',
          prop: 'qualityAssPeriod',
          minWidth: '140px',
        },
        {
          tooltip: true,
          label: '数量（单位）',
          prop: 'quantity',
          minWidth: '140px',
          render: (h, { row }) => {
            let result = [];
            result.push(`${row.quantity}${row.unitName || ''}`);
            return h('div', result);
          },
        },
        {
          tooltip: true,
          label: '单价（元）',
          prop: 'price',
          minWidth: '140px',
          editRender: {
            name: 'input',
            attrs: { type: 'text', placeholder: '请输入单价' },
          },
          render: (h, { row }) => {
            let result = [];
            if (this.edit) {
              result.push(
                <el-input-number v-model={row.price} min={0} precision={2} controls={false} onChange={val => this.handleRowChange(val, row)} placeholder='请输入单价'></el-input-number>,
              );
            } else {
              result.push(row.price);
            }
            return h('div', result);
          },
        },
        {
          tooltip: true,
          label: '金额（元）',
          prop: 'rowAmount',
          minWidth: '140px',
          render: (h, { row }) => {
            row.rowAmount = row.price * row.quantity;
            return h('div', [`${row.rowAmount}`]);
          },
        },
      ];
    },
  },
  methods: {
    handleRowChange (val, row) {
      const lists = this.list;
      lists.map(item => {
        if (item.id === row.id) {
          item.price = row.price;
        }
        return item;
      });
      this.$emit('update:list', lists);
    },
  },
};
</script>
